export const PHONE_DISPLAY = "859-537-0211";
export const PHONE_TEL = "+18595370211";
export const SMS_URL =
  "sms:+18595370211?body=" +
  encodeURIComponent("Aloha Lucho, I would like a free estimate. My property is in: ");
export const CALL_URL = "tel:+18595370211";
export const STRIPE_PAYMENT_LINK = "";
export const EMAIL = "luchogomez591@gmail.com";
export const FACEBOOK_URL = "https://www.facebook.com/luchogomezconsulting";
export const INSTAGRAM_URL = "https://www.instagram.com/luchogomezconsulting";

export const CDN =
  "https://d8j0ntlcm91z4.cloudfront.net/user_3GQMdjXI4CC6Kn0Qn4wfm3z7RiO/";
const GEN =
  "https://static.prod-images.emergentagent.com/jobs/2aedb661-cc3d-4559-a8d2-02703d385e02/images/";

export const SERVICES = [
  {
    name: "Property & Land Care",
    img: CDN + "hf_20260830_190920_689d188c-b1f7-4371-b20d-baebd2c5ac63_min.webp",
    blurb:
      "The core of the work: yard cleanups, mowing and guinea grass clearing that keep Kaua'i lots healthy, open and walkable year round.",
    scope: ["Yard cleanups", "Mowing & weed eating", "Guinea grass clearing", "Brush cutting", "Green waste removal"],
  },
  {
    name: "Animal & Farm Help",
    img: CDN + "hf_20260830_190920_dcab483b-f036-42e8-8fde-505f665257b1_min.webp",
    blurb:
      "Steady, calm hands for horses and farm animals on Kaua'i, on a schedule or on call.",
    scope: ["Horse handling & basic training", "Feeding & daily care", "Animal husbandry", "Farm check-ins"],
  },
  {
    name: "Property Management",
    img: CDN + "hf_20260830_190920_0fc4301d-eee0-4200-8cda-b43e3ed1ec91_min.webp",
    blurb:
      "On-island eyes and hands for off-island owners. Photos, updates and no surprises while you are away.",
    scope: ["Property checks", "Meet contractors", "Coordinate repairs", "Photo updates"],
  },
  {
    name: "Pond & Water Feature Care",
    img: CDN + "hf_20260830_191044_59f65556-d835-4ffd-ae64-3e7eaa290dbf_min.webp",
    blurb:
      "Clean, clear, balanced water for koi ponds and water features across the island.",
    scope: ["Pond cleaning", "Filter service", "Water refresh", "Algae control", "Pump checks"],
  },
  {
    name: "Tree Work & Trimming",
    img: CDN + "hf_20260830_191044_dddd3c83-9012-45b0-8f1c-8b09e01ee825_min.webp",
    blurb:
      "Light tree work done carefully, with trusted local specialists brought in for the heavy lifts.",
    scope: ["Tree trimming & pruning", "Canopy thinning", "Branch removal", "Storm cleanup"],
  },
  {
    name: "Hauling & Dump Runs",
    img: CDN + "hf_20260830_191044_04af79ef-37c5-4eb9-b4b9-447785543508_min.webp",
    blurb: "The truck shows up, the pile disappears. Clean, reliable junk and debris removal.",
    scope: ["Debris removal", "Junk hauling", "Yard waste removal"],
  },
  {
    name: "Fence Installation & Repair",
    img: GEN + "86a4c9fa0abbdda6703cb363651f89538a122e8ec21a60146db79c36fc046802.jpeg",
    blurb:
      "Pasture lines, privacy fences and garden fencing — built straight and repaired right for Kaua'i weather.",
    scope: ["Pasture & ranch fencing", "Privacy fence repair", "Gate repair & hanging", "Post replacement"],
  },
  {
    name: "Landscaping & Planting",
    img: GEN + "62b01e1e2001ab2d2ff8aa257151ef2ec2a78e36e337175d96c7ce0d7e4712a5.jpeg",
    blurb:
      "Tropical planting and garden beds that thrive in Kaua'i sun and rain, kept tidy season after season.",
    scope: ["Tropical planting", "Garden bed builds", "Mulching", "Hedge shaping", "Lawn care"],
  },
  {
    name: "Pressure Washing",
    img: GEN + "cab682dd04f880db8fde9cc890785845d50a1b1825cae8cb2a095955a114b021.jpeg",
    blurb:
      "Driveways, walkways, lanais and siding brought back to clean — mildew and red dirt don't stand a chance.",
    scope: ["Driveways & walkways", "Lanais & patios", "Siding & exterior walls", "Mildew removal"],
  },
  {
    name: "Gutter & Roofline Cleaning",
    img: GEN + "38c192a00fb699ae75c506bba533f8d7c78576d613ea4f968b39e769872ed267.jpeg",
    blurb:
      "Kaua'i rain needs somewhere to go. Gutters cleared, downspouts flushed, rooflines free of debris.",
    scope: ["Gutter clearing", "Downspout flushing", "Roofline debris removal", "Pre-storm checks"],
  },
  {
    name: "Vacation Rental & Turnover Care",
    img: GEN + "3eceba3267fc784458d910211076521532114f79737caf87508df90c937ce3c3.jpeg",
    blurb:
      "Guest-ready grounds for Kaua'i vacation rentals: exterior upkeep, between-stay checks and fast fixes.",
    scope: ["Guest-ready grounds", "Between-stay checks", "Exterior upkeep", "Fast small fixes"],
  },
  {
    name: "Mosquito Control",
    img: CDN + "hf_20260830_191154_f5c716ea-6bae-42c9-9f27-f818c8675022_min.webp",
    blurb:
      "Take the yard back in the evenings with misting and perimeter treatment, ongoing or one-time.",
    scope: ["Misting & treatment", "Perimeter spraying", "Ongoing & one-time options"],
  },
];

export const PAIRS = [
  {
    label: "Guinea grass clearing",
    before: CDN + "hf_20260830_191154_3ff7723a-91a8-44aa-a872-65719ea341bb_min.webp",
    after: CDN + "hf_20260830_191449_02f8ad06-6ce5-40b8-9d83-7d87758b9568_min.webp",
  },
  {
    label: "Pond revival",
    before: CDN + "hf_20260830_191154_398c45df-1e13-484e-bb84-26a5a101c161_min.webp",
    after: CDN + "hf_20260830_191449_53155ece-04e2-4b19-a118-8919f5f00218_min.webp",
  },
];

export const FAQS = [
  {
    q: "What areas of Kaua'i do you serve?",
    a: "Lucho is based around Lihu'e and Kapa'a and proudly serves all of Kaua'i — Princeville, Hanalei, Po'ipu, Koloa, Waimea and everywhere in between. If your property is on the island, he can get to it.",
  },
  {
    q: "How much does property care on Kaua'i cost?",
    a: "Every property is different, so every job starts with a free estimate — on-site or from photos. You get an honest written quote by text or email before any work begins. No pressure, no surprises.",
  },
  {
    q: "Can you clear overgrown guinea grass and brush?",
    a: "Yes — guinea grass clearing, brush cutting, yard cleanups and green waste removal are the heart of the work. Overgrown Kaua'i lots become open, walkable land again, and hauling is included when you need it.",
  },
  {
    q: "Do you help off-island property owners?",
    a: "Many clients live on the mainland. Property management includes regular property checks, meeting contractors, coordinating repairs and photo updates, so you always know how your Kaua'i property is doing.",
  },
  {
    q: "Do you take care of horses and farm animals?",
    a: "Yes. Animal and farm help covers horse handling and basic training, feeding and daily care, general animal husbandry and farm check-ins while you are away.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes. Lucho Gomez Connect is licensed and insured, operating as Luciano Gomez Consulting LLC, registered in Hawaii.",
  },
  {
    q: "How do I pay my invoice?",
    a: "After the work is done you receive an invoice number. You can pay securely online by card through Stripe from anywhere in the world, right on this website.",
  },
  {
    q: "How do I get a free estimate?",
    a: "Call or text 859-537-0211, email luchogomez591@gmail.com, or send the request form on this page. Estimates are always free.",
  },
];

export const MARQUEE_ITEMS = [
  "Land Clearing",
  "Guinea Grass Removal",
  "Koi Pond Care",
  "Horse & Farm Help",
  "Tree Trimming",
  "Hauling & Dump Runs",
  "Fence Repair",
  "Pressure Washing",
  "Landscaping",
  "Gutter Cleaning",
  "Rental Turnovers",
  "Mosquito Control",
];
